import { gql } from '@apollo/client'

export interface LockUnlockDealResponse {
  lockUnlockDeal: {
    isSuccess: boolean
    expireMessage: string
    error: string
  }
}

export const LOCK_DEAL_MUTATION_STRING = `
  mutation lockUnlockDeal($bdId: Int!, $lockFlag: Boolean!, $userId: String) {
    lockUnlockDeal(bdId: $bdId, lockFlag: $lockFlag, userId: $userId) {
      error
      isSuccess
    }
  }
`

const LOCK_DEAL_MUTATION = gql(LOCK_DEAL_MUTATION_STRING)

export default LOCK_DEAL_MUTATION
